// extracted by mini-css-extract-plugin
export default {"container":"SharedLayout_container__SSFEK"};